module.exports = __webpack_public_path__ + "img/Phone.c640c096.png";